import styled from "styled-components";

const StyledMain = styled.main`
  word-break: break-word;
`;

export default StyledMain;
